import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { get, set, identity } from 'lodash'

import FilterBarContext from '../context'
import { DatePicker, DatePickerInput } from '../../DatePicker'
import { buildPathToValue, findSectionElement } from '../utils'

const Date = ({ items, onChange, hierarchy }) => {
  const { filters, serverSideT } = useContext(FilterBarContext)

  const onDateChange = (path) => (_, dateStr) => {
    onChange((filters, newSections) => {
      const clonedFilters = { ...filters }
      set(clonedFilters, path, dateStr)

      const clonedNewSections = [...newSections]
      const sectionElement = findSectionElement(clonedNewSections, path)

      // Val is deprecating
      // This delete is for normalize using always the same key
      delete sectionElement.val
      sectionElement.value = dateStr

      return { clonedFilters, clonedNewSections }
    }, path)
  }

  return items.map(({ label, key }) => {
    const path = buildPathToValue(hierarchy, key)

    return (
      <DatePicker
        key={path}
        className='filterDatePicker'
        datePickerType='single'
        dateFormat='Y/m/d'
        value={get(filters, path)}
        onChange={onDateChange(path)}
      >
        <DatePickerInput id={`date-${path}`} labelText={serverSideT(label)} />
      </DatePicker>
    )
  })
}

Date.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  hierarchy: PropTypes.array
}

Date.defaultProps = {
  items: [],
  onChange: identity,
  hierarchy: []
}

export default React.memo(Date)
